import React, { useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { useData } from "@/context/DataContext";
import { formatApiErrorDetail } from "@/lib/api";
import { zonaDispositivo } from "@/lib/zona";

const KEY = "aldia_zona_descartada";
const ZONAS = (() => {
  try { return Intl.supportedValuesOf("timeZone").filter((z) => z.includes("/")); } catch { return ["Europe/Madrid", "Atlantic/Canary", "Europe/Lisbon", "Europe/London", "Europe/Paris"]; }
})();

const useCambiarZona = () => {
  const { setPushPrefs } = useData();
  return async (tz) => {
    try { await setPushPrefs({ timezone: tz }); toast.success("Zona horaria actualizada", { description: tz }); setTimeout(() => window.location.reload(), 700); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo cambiar."); }
  };
};

// Aviso cuando el móvil está en otra zona: nunca cambia la cuenta sin confirmación.
export const ZonaAviso = () => {
  const { pushPrefs } = useData();
  const cambiar = useCambiarZona();
  const disp = zonaDispositivo();
  const [oculto, setOculto] = useState(() => localStorage.getItem(KEY) === disp);
  if (!pushPrefs.timezone || !disp || !disp.includes("/") || disp === pushPrefs.timezone || oculto) return null;
  return (
    <div data-testid="zona-aviso" className="bg-[#FFFBEB] border border-[#FDE68A] rounded-2xl p-4 space-y-3">
      <p className="text-base text-[#92400E]">Tu dispositivo está en <strong>{disp}</strong>, pero tu cuenta está configurada en <strong>{pushPrefs.timezone}</strong>. ¿Quieres cambiarla?</p>
      <div className="flex flex-wrap gap-2">
        <button data-testid="zona-aviso-cambiar" onClick={() => cambiar(disp)} className="min-h-[44px] px-4 rounded-xl bg-[#3A6B56] text-white font-semibold text-sm">Cambiar a {disp}</button>
        <button data-testid="zona-aviso-mantener" onClick={() => { localStorage.setItem(KEY, disp); setOculto(true); }}
          className="min-h-[44px] px-4 rounded-xl bg-white border border-[#E5DFD5] text-[#4A5550] font-semibold text-sm">Mantener {pushPrefs.timezone}</button>
      </div>
    </div>
  );
};

export const ZonaHoraria = () => {
  const { pushPrefs } = useData();
  const cambiar = useCambiarZona();
  const actual = pushPrefs.timezone || "Europe/Madrid";
  return (
    <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm space-y-3" data-testid="perfil-zona-horaria">
      <h2 className="font-heading text-lg font-bold text-[#1C2421] flex items-center gap-2"><Icons.Globe2 size={20} className="text-[#3A6B56]" /> Zona horaria</h2>
      <p className="text-sm text-[#6E7A74]">Todas las fechas y horas de AL DÍA (hoy, citas, planes, avisos, gestiones y correos) usan esta zona. El cambio de hora de verano e invierno se aplica solo.</p>
      <select data-testid="perfil-zona-select" value={actual} onChange={(e) => cambiar(e.target.value)}
        className="w-full min-h-[48px] px-3 rounded-xl bg-white border border-[#E5DFD5] text-base text-[#1C2421]">
        {(ZONAS.includes(actual) ? ZONAS : [actual, ...ZONAS]).map((z) => <option key={z} value={z}>{z}</option>)}
      </select>
      <ZonaAviso />
    </div>
  );
};
